import "../HomePage/CreateEditHomePageContent/CreateEditHomePageContent.scss";
import ContentSectionOne from "../ManageThemeParkContents/ManageThemeParkContents";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { API_RESPONSE, COMMON_CONSTANTS, I18_TRANSLATION_COMMON, ROUTES, TOASTER_CONFIGS } from "../../../Utilities/Constants/Constants";
import { useTranslation } from "react-i18next";
import BackArrow from "../../../../Assets/schools/back_button.svg";
import { axiosInstance } from "../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../Utilities/Constants/ApiEndpoints";
import { Field, Formik } from "formik";
import * as yup from "yup";
import { toast } from "react-toastify";


const CreateEditHomePageContent = () => {
  const { t } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const location = useLocation();
  const navigate = useNavigate();
  const [ activeStep, setActiveStep ] = useState(`${COMMON_CONSTANTS.ONE}`)
  const { id } = useParams();
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [managethemeparkdata, setManagethemeparkdata] = useState({})


useEffect(() => {
  const pathName = window.location?.pathname;
  const payload = {
    record_area: pathName.slice(1)
  }
  axiosInstance.post(`${API_END_POINTS?.RECORD_AREA}`, payload).then((response: any) => {
  }).catch(() => {
  })
}, [])

  const [initialValues, setInitialValues] = useState({
    location_heading:"",
    location_description:"",
    location_heading_ar:"",
    location_description_ar:"",
    month_topic:"",
    month_heading:"",
    month_description:"",
    month_topic_ar:"",
    month_heading_ar:"",
    month_description_ar:"",
    splash_heading:"",
    splash_description:"",
    splash_heading_ar:"",
    splash_description_ar:"",
    event_heading:"",
    event_description:"",
    event_heading_ar:"",
    event_description_ar:"",
    review_heading:"",
    review_heading_ar:"",
  })

  

  const formValidationSchema = yup.object({
    month_topic: yup.string().required("field is required"),
    month_topic_ar: yup.string().required("field is required"),
    month_heading: yup.string().required("month heading is required"),
    month_heading_ar: yup.string().required("month heading ar is required"),
    splash_heading: yup.string().required("field is required"),
    splash_heading_ar: yup.string().required("field is required"),
    event_heading: yup.string().required("field is required"),
    event_heading_ar: yup.string().required("field is required"),
    review_heading: yup.string().required("field is required"),
    review_heading_ar: yup.string().required("field is required"),
  })

  const onSubmitData = (value: any) => {

    let payload = {
      location:{
        heading: value.location_heading,
        heading_ar: value.location_heading_ar,
        description: value.location_description,
        description_ar: value.location_description_ar,
      },
      month:{
        topic:value.month_topic,
        topic_ar:value.month_topic_ar,
        heading:value.month_heading,
        heading_ar:value.month_heading_ar,
        description:value.month_description,
        description_ar:value.month_description_ar,
      },
      splash:{
        heading:value.splash_heading,
        heading_ar:value.splash_heading_ar,
        description:value.splash_description,
        description_ar:value.splash_description_ar,
      },
      event:{
        heading:value.event_heading,
        heading_ar:value.event_heading_ar,
        description:value.event_description,
        description_ar:value.event_description_ar,
      },
      review:{
        heading:value.review_heading,
        heading_ar:value.review_heading_ar,
      }
    }
    postThemeParkContent(payload)
  }

  const postThemeParkContent = (payload:any)=> {
    axiosInstance
    .post(API_END_POINTS.THEME_PARK_MANAGE_CONTENT, payload)
    .then((response)=>{
      if(response.data.status === API_RESPONSE.TRUE) {
        toast.success(response.data.message, TOASTER_CONFIGS);
      }
    })
  }

  const getThemeParkContent = () => {
    axiosInstance
    .get(API_END_POINTS.THEME_PARK_MANAGE_CONTENT)
    .then((response)=>{
      if(response.data.status === API_RESPONSE.TRUE) {
        setGetData(response.data.result.data)

      }
    })
  }

  const setGetData = (data:any) => {
    setInitialValues({
      location_heading: data.location.heading || "",
      location_description: data.location.description || "",
      location_heading_ar: data.location.heading_ar|| "",
      location_description_ar: data.location.description_ar || "",
      month_topic: data.month.topic || "",
      month_heading: data.month.heading || "",
      month_description: data.month.description || "",
      month_topic_ar: data.month.topic_ar || "", 
      month_heading_ar: data.month.heading_ar || "",
      month_description_ar: data.month.description_ar || "",
      splash_heading: data.splash.heading || "",
      splash_description: data.splash.description || "",
      splash_heading_ar: data.splash.heading_ar || "",
      splash_description_ar: data.splash.description_ar || "",
      event_heading: data.event.heading || "",
      event_description: data.event.description || "",
      event_heading_ar: data.event.heading_ar || "",
      event_description_ar: data.event.description_ar || "",
      review_heading: data.review.heading || "",
      review_heading_ar: data.review.heading_ar || "",
    })
  }

  useEffect(()=>{
    getThemeParkContent();
  }, [])

  useEffect(()=>{
      location.pathname === ROUTES.CREATE_HOME_PAGE_CONTENTS ? setActiveStep(`${COMMON_CONSTANTS.ONE}`) : setActiveStep(`${COMMON_CONSTANTS.TWO}`)
  },[])
  
  return(
    <div className="create-edit-content-wrapper">
         <div className="row">
                      <div className="col-md-12">
                          <div className='arrow-wrap'>
                              <img src={BackArrow} className='EditSchool-backarrow' onClick={() => { navigate(-1) }} />
                              <h5 className='name-title mt-1 ms-2'>{ id ?  t('Theme Park Content')  : t('Theme Park Content')}</h5>
                          </div>
  
                      </div>
                      <div className="content-form-wrapper mx-auto">
                        <Formik
                          enableReinitialize
                          initialValues={initialValues}
                          onSubmit={(values, actions) => {
                            onSubmitData(values);
                          }}
                        >
                          {(formik:any)=>{
                            return(
                              <>

                              <label className="form-label">{"location"}</label>
                              <label className="form-label">English</label>
                                <div className="col-md-12">

                                  <div className="input-wrapper">
                                    <Field
                                      name={"location_heading"}
                                      className="form-input"
                                      placeholder={"Heading"}
                                    />
                                    {formik.touched.location_heading &&
                                      formik.errors.location_heading && (
                                        <p className="validation">
                                          {t(
                                            `${formik.touched.location_heading &&
                                            formik.errors.location_heading
                                            }`
                                          )}
                                        </p>
                                      )}
                                  </div>

                                  <div className="input-wrapper mt-2">
                                    <Field
                                      as="textarea"
                                      name={"location_description"}
                                      className="form-input"
                                      placeholder={"Description"}
                                      onKeyPress={(event: any) => {
                                        if (
                                          250 -
                                          formik.values["location_description"]
                                            .length <=
                                          0
                                        )
                                          event?.preventDefault();
                                      }}
                                      onPaste={(event: any) => {
                                        const updatedValue =
                                          formik.values["location_description"] +
                                          event.clipboardData.getData("text");
                                        if (updatedValue?.length > 250) {
                                          event.preventDefault();
                                        }
                                      }}
                                    />
                                    <p className="characters-left">
                                      {250 -
                                        formik.values["location_description"]
                                          .length}{" "}
                                      {t("characters left")}
                                    </p>
                                    {formik.touched["location_description"] &&
                                      formik.errors["location_description"] && (
                                        <p className="validation">
                                          {t(
                                            `${formik.touched["location_description"] &&
                                            formik.errors["location_description"]
                                            }`
                                          )}
                                        </p>
                                      )}
                                  </div>
                                </div>

                                <label className="form-label">Arabic</label>
                                <div className="col-md-12">
  
                                  <div className="input-wrapper">
                                    <Field
                                      name={"location_heading_ar"}
                                      className="form-input"
                                      placeholder={"Heading in Arabic"}
                                    />
                                    {formik.touched["location_heading_ar"] &&
                                      formik.errors["location_heading_ar"] && (
                                        <p className="validation">
                                          {t(
                                            `${formik.touched["location_heading_ar"] &&
                                            formik.errors["location_heading_ar"]
                                            }`
                                          )}
                                        </p>
                                      )}
                                  </div>

                                  <div className="input-wrapper mt-2">
                                    <Field
                                      as="textarea"
                                      name={"location_description_ar"}
                                      className="form-input"
                                      placeholder={"Description in Arabic"}
                                      onKeyPress={(event: any) => {
                                        if (
                                          250 -
                                          formik.values["location_description_ar"]
                                            .length <=
                                          0
                                        )
                                          event?.preventDefault();
                                      }}
                                      onPaste={(event: any) => {
                                        const updatedValue =
                                          formik.values["heading_description"] +
                                          event.clipboardData.getData("text");
                                        if (updatedValue?.length > 250) {
                                          event.preventDefault();
                                        }
                                      }}
                                    />
                                    <p className="characters-left">
                                      {250 -
                                        formik.values["location_description_ar"]
                                          .length}{" "}
                                      {t("characters left")}
                                    </p>
                                    {formik.touched["location_description_ar"] &&
                                      formik.errors["location_description_ar"] && (
                                        <p className="validation">
                                          {t(
                                            `${formik.touched["location_description_ar"] &&
                                            formik.errors["location_description_ar"]
                                            }`
                                          )}
                                        </p>
                                      )}
                                  </div>
                                </div>

                              <label className="form-label">{"Month"}</label>
                              <label className="form-label">English</label>
                                <div className="col-md-12">

                                <div className="input-wrapper mb-2">
                                    <Field
                                      name={"month_topic"}
                                      className="form-input"
                                      placeholder={"month Topic"}
                                    />
                                    {formik.touched.month_topic &&
                                      formik.errors.month_topic && (
                                        <p className="validation">
                                          {t(
                                            `${formik.touched.month_topic &&
                                            formik.errors.month_topic
                                            }`
                                          )}
                                        </p>
                                      )}
                                  </div>

                                  <div className="input-wrapper">
                                    <Field
                                      name={"month_heading"}
                                      className="form-input"
                                      placeholder={"month heading"}
                                    />
                                    {formik.touched.month_heading &&
                                      formik.errors.month_heading && (
                                        <p className="validation">
                                          {t(
                                            `${formik.touched.month_heading &&
                                            formik.errors.month_heading
                                            }`
                                          )}
                                        </p>
                                      )}
                                  </div>

                                  <div className="input-wrapper mt-2">
                                    <Field
                                      as="textarea"
                                      name={"month_description"}
                                      className="form-input"
                                      placeholder={"Month Description"}
                                      onKeyPress={(event: any) => {
                                        if (
                                          250 -
                                          formik.values["month_description"]
                                            .length <=
                                          0
                                        )
                                          event?.preventDefault();
                                      }}
                                      onPaste={(event: any) => {
                                        const updatedValue =
                                          formik.values["month_description"] +
                                          event.clipboardData.getData("text");
                                        if (updatedValue?.length > 250) {
                                          event.preventDefault();
                                        }
                                      }}
                                    />
                                    <p className="characters-left">
                                      {250 -
                                        formik.values["month_description"]
                                          .length}{" "}
                                      {t("characters left")}
                                    </p>
                                    {formik.touched["month_description"] &&
                                      formik.errors["month_description"] && (
                                        <p className="validation">
                                          {t(
                                            `${formik.touched["month_description"] &&
                                            formik.errors["month_description"]
                                            }`
                                          )}
                                        </p>
                                      )}
                                  </div>
                                </div>

                                <label className="form-label">Arabic</label>
                                <div className="col-md-12">

                                <div className="input-wrapper mb-2">
                                    <Field
                                      name={"month_topic_ar"}
                                      className="form-input"
                                      placeholder={"month Topic in Arabic"}
                                    />
                                    {formik.touched["month_topic_ar"] &&
                                      formik.errors["month_topic_ar"] && (
                                        <p className="validation">
                                          {t(
                                            `${formik.touched["month_topic_ar"] &&
                                            formik.errors["month_topic_ar"]
                                            }`
                                          )}
                                        </p>
                                      )}
                                  </div>
                                  
                                  <div className="input-wrapper">
                                    <Field
                                      name={"month_heading_ar"}
                                      className="form-input"
                                      placeholder={"month heading in Arabic"}
                                    />
                                    {formik.touched["month_heading_ar"] &&
                                      formik.errors["month_heading_ar"] && (
                                        <p className="validation">
                                          {t(
                                            `${formik.touched["month_heading_ar"] &&
                                            formik.errors["month_heading_ar"]
                                            }`
                                          )}
                                        </p>
                                      )}
                                  </div>

                                  <div className="input-wrapper mt-2">
                                    <Field
                                      as="textarea"
                                      name={"month_description_ar"}
                                      className="form-input"
                                      placeholder={"Month Description in Arabic"}
                                      onKeyPress={(event: any) => {
                                        if (
                                          250 -
                                          formik.values["words left"]
                                            .length <=
                                          0
                                        )
                                          event?.preventDefault();
                                      }}
                                      onPaste={(event: any) => {
                                        const updatedValue =
                                          formik.values["heading_description"] +
                                          event.clipboardData.getData("text");
                                        if (updatedValue?.length > 250) {
                                          event.preventDefault();
                                        }
                                      }}
                                    />
                                    <p className="characters-left">
                                      {250 -
                                        formik.values["month_description_ar"]
                                          .length}{" "}
                                      {t("characters left")}
                                    </p>
                                    {formik.touched["month_description_ar"] &&
                                      formik.errors["month_description_ar"] && (
                                        <p className="validation">
                                          {t(
                                            `${formik.touched["month_description_ar"] &&
                                            formik.errors["month_description_ar"]
                                            }`
                                          )}
                                        </p>
                                      )}
                                  </div>
                                </div>

                                <label className="form-label">{"Splash"}</label>
                                <label className="form-label">English</label>
                                  <div className="col-md-12">
                                    <div className="input-wrapper">
                                      <Field
                                        name={"splash_heading"}
                                        className="form-input"
                                        placeholder={"Splash Heading"}
                                      />
                                      {formik.touched.splash_heading &&
                                        formik.errors.splash_heading && (
                                          <p className="validation">
                                            {t(
                                              `${formik.touched.splash_heading &&
                                              formik.errors.splash_heading
                                              }`
                                            )}
                                          </p>
                                        )}
                                    </div>
                                    <div className="input-wrapper mt-2">
                                      <Field
                                        as="textarea"
                                        name={"splash_description"}
                                        className="form-input"
                                        placeholder={"Splash Description"}
                                        onKeyPress={(event: any) => {
                                          if (
                                            250 -
                                            formik.values["splash_description"]
                                              .length <=
                                            0
                                          )
                                            event?.preventDefault();
                                        }}
                                        onPaste={(event: any) => {
                                          const updatedValue =
                                            formik.values["splash_description"] +
                                            event.clipboardData.getData("text");
                                          if (updatedValue?.length > 250) {
                                            event.preventDefault();
                                          }
                                        }}
                                      />
                                      <p className="characters-left">
                                        {250 -
                                          formik.values["splash_description"]
                                            .length}{" "}
                                        {t("characters left")}
                                      </p>
                                      {formik.touched["splash_description"] &&
                                        formik.errors["splash_description"] && (
                                          <p className="validation">
                                            {t(
                                              `${formik.touched["splash_description"] &&
                                              formik.errors["splash_description"]
                                              }`
                                            )}
                                          </p>
                                        )}
                                    </div>
                                  </div>


                                  <label className="form-label">Arabic</label>
                                  <div className="col-md-12">
                                    <div className="input-wrapper">
                                      <Field
                                        name={"splash_heading_ar"}
                                        className="form-input"
                                        placeholder={"Splash heading in Arabic"}
                                      />
                                      {formik.touched["splash_heading_ar"] &&
                                        formik.errors["splash_heading_ar"] && (
                                          <p className="validation">
                                            {t(
                                              `${formik.touched["splash_heading_ar"] &&
                                              formik.errors["splash_heading_ar"]
                                              }`
                                            )}
                                          </p>
                                        )}
                                    </div>
                                    <div className="input-wrapper mt-2">
                                      <Field
                                        as="textarea"
                                        name={"splash_description_ar"}
                                        className="form-input"
                                        placeholder={"Splash Description in Arabic"}
                                        onKeyPress={(event: any) => {
                                          if (
                                            250 -
                                            formik.values["splash_description_ar"]
                                              .length <=
                                            0
                                          )
                                            event?.preventDefault();
                                        }}
                                        onPaste={(event: any) => {
                                          const updatedValue =
                                            formik.values["splash_description_ar"] +
                                            event.clipboardData.getData("text");
                                          if (updatedValue?.length > 250) {
                                            event.preventDefault();
                                          }
                                        }}
                                      />
                                      <p className="characters-left">
                                        {250 -
                                          formik.values["splash_description_ar"]
                                            .length}{" "}
                                        {t("characters left")}
                                      </p>
                                      {formik.touched["splash_description_ar"] &&
                                        formik.errors["splash_description_ar"] && (
                                          <p className="validation">
                                            {t(
                                              `${formik.touched["splash_description_ar"] &&
                                              formik.errors["splash_description_ar"]
                                              }`
                                            )}
                                          </p>
                                        )}
                                    </div>
                                  </div>


                                <label className="form-label">{"Events"}</label>
                                <label className="form-label">English</label>
                                  <div className="col-md-12">
                                    <div className="input-wrapper">
                                      <Field
                                        name={"event_heading"}
                                        className="form-input"
                                        placeholder={"Event Heading"}
                                      />
                                      {formik.touched.event_heading &&
                                        formik.errors.event_heading && (
                                          <p className="validation">
                                            {t(
                                              `${formik.touched.event_heading &&
                                              formik.errors.event_heading
                                              }`
                                            )}
                                          </p>
                                        )}
                                    </div>

                                    <div className="input-wrapper mt-2">
                                      <Field
                                        as="textarea"
                                        name={"event_description"}
                                        className="form-input"
                                        placeholder={"Event Description"}
                                        onKeyPress={(event: any) => {
                                          if (
                                            250 -
                                            formik.values["event_description"]
                                              .length <=
                                            0
                                          )
                                            event?.preventDefault();
                                        }}
                                        onPaste={(event: any) => {
                                          const updatedValue =
                                            formik.values["event_description"] +
                                            event.clipboardData.getData("text");
                                          if (updatedValue?.length > 250) {
                                            event.preventDefault();
                                          }
                                        }}
                                      />
                                      <p className="characters-left">
                                        {250 -
                                          formik.values["event_description"]
                                            .length}{" "}
                                        {t("characters left")}
                                      </p>
                                      {formik.touched["event_description"] &&
                                        formik.errors["event_description"] && (
                                          <p className="validation">
                                            {t(
                                              `${formik.touched["event_description"] &&
                                              formik.errors["event_description"]
                                              }`
                                            )}
                                          </p>
                                        )}
                                    </div>
                                  </div>


                                  <label className="form-label">Arabic</label>
                                  <div className="col-md-12">
                                    <div className="input-wrapper">
                                      <Field
                                        name={"event_heading_ar"}
                                        className="form-input"
                                        placeholder={"Event heading in Arabic"}
                                      />
                                      {formik.touched["event_heading_ar"] &&
                                        formik.errors["event_heading_ar"] && (
                                          <p className="validation">
                                            {t(
                                              `${formik.touched["event_heading_ar"] &&
                                              formik.errors["event_heading_ar"]
                                              }`
                                            )}
                                          </p>
                                        )}
                                    </div>
                                    <div className="input-wrapper mt-2">
                                      <Field
                                        as="textarea"
                                        name={"event_description_ar"}
                                        className="form-input"
                                        placeholder={"Event Description in Arabic"}
                                        onKeyPress={(event: any) => {
                                          if (
                                            250 -
                                            formik.values["event_description_ar"]
                                              .length <=
                                            0
                                          )
                                            event?.preventDefault();
                                        }}
                                        onPaste={(event: any) => {
                                          const updatedValue =
                                            formik.values["event_description_ar"] +
                                            event.clipboardData.getData("text");
                                          if (updatedValue?.length > 250) {
                                            event.preventDefault();
                                          }
                                        }}
                                      />
                                      <p className="characters-left">
                                        {250 -
                                          formik.values["event_description_ar"]
                                            .length}{" "}
                                        {t("characters left")}
                                      </p>
                                      {formik.touched["event_description_ar"] &&
                                        formik.errors["event_description_ar"] && (
                                          <p className="validation">
                                            {t(
                                              `${formik.touched["event_description_ar"] &&
                                              formik.errors["event_description_ar"]
                                              }`
                                            )}
                                          </p>
                                        )}
                                    </div>
                                  </div>


                                <label className="form-label">{"Review"}</label>
                                <label className="form-label">English</label>
                                  <div className="col-md-12">
                                    <div className="input-wrapper mb-2">
                                      <Field
                                        name={"review_heading"}
                                        className="form-input"
                                        placeholder={"Review Heading"}
                                      />
                                      {formik.touched.review_heading &&
                                        formik.errors.review_heading && (
                                          <p className="validation">
                                            {t(
                                              `${formik.touched.review_heading &&
                                              formik.errors.review_heading
                                              }`
                                            )}
                                          </p>
                                        )}
                                    </div>

                                    <label className="form-label">Arabic</label>
                                    <div className="input-wrapper mb-2">
                                      <Field
                                        name={"review_heading_ar"}
                                        className="form-input"
                                        placeholder={"Review heading in Arabic"}
                                      />
                                      {formik.touched["review_heading_ar"] &&
                                        formik.errors["review_heading_ar"] && (
                                          <p className="validation">
                                            {t(
                                              `${formik.touched["review_heading_ar"] &&
                                              formik.errors["review_heading_ar"]
                                              }`
                                            )}
                                          </p>
                                        )}
                                    </div>
                                  </div>

                                  <div className="submit-btn-wrapper">
                                    <button
                                      className="cancel_button"
                                      onClick={() => {
                                        navigate(-1);
                                      }}
                                    >
                                      {t("Cancel")}
                                    </button>
                                    <button
                                      type="submit"
                                      className="btn btn-secondary submit-btn"
                                      onClick={() => {
                                        formik.handleSubmit();
                                        setFormSubmitted(true);
                                        navigate(-1);
                                      }}
                                    >
                                      {id ? "Update" : "Submit"}
                                    </button>
                                  </div>
                              </>
                            )
                          }}
                        </Formik>
                        
                      </div>
          </div>
   

    </div>
  )
     
};

export default CreateEditHomePageContent;
